<template>
  <div class="modal fade show custom-modal" id="NcbRetentionModal" role="dialog" :class="{'modal-show':showNcbRetentionModal}">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header ml-3 pl-2">
          <button type="button" class="close text-right outline-none" data-dismiss="modal" id="ncb-close">&times;</button>
        </div>
        
        <div class="modal-body mt-4 pl-5 pb-5">
           <div class="row">
              <p class="text-center font-weight-bold mr-4"> Do you have an NCB Retention Certificate for transfering NCB on this policy?</p>
              <div class="col-12 text-center mt-5" >
                <button
                  type="button"
                  class="btn bgc-btn-primary  mr-5"
                  data-dismiss="modal"
                  id="ncb-yes"
                  @click="handleNcbRetentionProceed()"
                > Yes </button>   
                <button
                  type="button"
                  class="btn bgc-btn-secondary mr-3 "
                  data-dismiss="modal"
                  id="ncb-no"
                  @click="handleNcbRetentionCancel()"
                > No </button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "@vue/composition-api";
export default {
  name: "ncbRetentionModal",
  props:['showNcbRetentionModal'],
  components: {
  },
  setup(props, context) {
    let state = reactive({
    });
    function handleNcbRetentionProceed(){
      context.parent.handleNcbRetentionProceed();
    }
    function handleNcbRetentionCancel(){
      context.parent.handleNcbRetentionCancel();
    }
    return {
      state,
      handleNcbRetentionProceed,
      handleNcbRetentionCancel,

    };
  },
};
 
</script>

<style scoped>
.outline-none{
    outline: none;
}
.checkbox-position {
  left: 15px;
}
.style-border {
  border-bottom: 1px solid #c7c7c7;

}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
</style>